/**
 * D5 — vocabulário das categorias de grupo. A cor vem do servidor como NOME DE TOKEN
 * (`chart-1…8`); aqui ela vira classe estática do Tailwind (classe montada por string não
 * entra no CSS gerado). Nada de hex.
 */
import type { GroupCategory } from '../../lib/api';

export type CategoryColor = GroupCategory['color'];

export const CATEGORY_COLORS: readonly CategoryColor[] = [
  'chart-1',
  'chart-2',
  'chart-3',
  'chart-4',
  'chart-5',
  'chart-6',
  'chart-7',
  'chart-8',
];

/** O ponto colorido do badge. Classes ESTÁTICAS, uma por token. */
export const CATEGORY_DOT: Record<CategoryColor, string> = {
  'chart-1': 'bg-chart-1',
  'chart-2': 'bg-chart-2',
  'chart-3': 'bg-chart-3',
  'chart-4': 'bg-chart-4',
  'chart-5': 'bg-chart-5',
  'chart-6': 'bg-chart-6',
  'chart-7': 'bg-chart-7',
  'chart-8': 'bg-chart-8',
};

/** Nome da cor para leitor de tela e para o seletor — cor nunca é canal único. */
export const CATEGORY_COLOR_NAME: Record<CategoryColor, string> = {
  'chart-1': 'Violeta',
  'chart-2': 'Laranja',
  'chart-3': 'Azul-petróleo',
  'chart-4': 'Verde',
  'chart-5': 'Vermelho',
  'chart-6': 'Rosa',
  'chart-7': 'Lilás',
  'chart-8': 'Cinza',
};

/** O recorte da categoria em uma frase. `null` de gente/vagas = "sem contagem", nunca 0. */
export function categorySummary(category: GroupCategory): string {
  const grupos = `${category.groupsCount} ${category.groupsCount === 1 ? 'grupo' : 'grupos'}`;
  if (category.groupsCount === 0) return 'Nenhum grupo nesta categoria';
  const pessoas =
    category.participants === null
      ? 'pessoas sem contagem ainda'
      : `${category.participants.toLocaleString('pt-BR')} pessoas`;
  const vagas =
    category.seatsLeft === null
      ? null
      : `${category.seatsLeft.toLocaleString('pt-BR')} ${category.seatsLeft === 1 ? 'vaga' : 'vagas'}`;
  const semContagem =
    category.groupsWithoutCount > 0 ? ` (${category.groupsWithoutCount} sem contagem)` : '';
  return [grupos, pessoas, vagas].filter(Boolean).join(' · ') + semContagem;
}
